/**
 * Shared surface styles for client portal lists / empty states and matching firm tables.
 * Keeps `bg-white border … shadow-sm` in sync with {@link Card} in WorkflowFormPrimitives.
 */
export const clientSurfaceCardClass = 'rounded-lg border border-gray-200 bg-white shadow-sm';

/** Centered empty / zero-state pane (large icon + title + hint). */
export const clientEmptyStateCardClass = `${clientSurfaceCardClass} p-8 text-center sm:p-12`;

/** List + toolbar shell (Analyses, Archived, run history standalone card, firm tables). */
export const clientDataPanelClass = `${clientSurfaceCardClass} overflow-hidden`;
